// extracted by mini-css-extract-plugin
module.exports = {"loading-spinner":"_2vEUg1BCrBbI1VJ2Nyo8fP"};